import React from "react";

const LoadingGear = () => {
  return (
    <div className="row popup-content column">
      <div className="small-12 columns">
        <div className="small-12 text-center">
          <br />
          <img alt="Loading Gear" src="/images/gears.gif" />
          <br />
        </div>
      </div>
    </div>
  );
};

export default LoadingGear;
